export default {
  reservations: 'Réservations',
  activated: 'Activé',
  deactivated: 'Désactivé',
  reservations_deactivated: 'Les réservations sont désactivées.',
  tabs: {
    general: 'Général',
    information: 'Informations',
  },
  sections: {
    notifications_confirmation: 'Notifications et confirmation',
    notifications_confirmation_description: 'Comment les clients réservent et comment vous êtes notifié.',
    who_can_book: 'Qui peut réserver',
    who_can_book_description: 'Limites de taille de groupe pour les réservations en ligne.',
    when_how_bookings_work: 'Quand et comment les réservations fonctionnent',
    when_how_bookings_work_description:
      'Règles de délai, durée et capacité déterminant les créneaux visibles par les clients.',
  },
  google: {
    label: 'Afficher les réservations sur Google',
  },
  storefront: {
    label: 'Afficher les réservations sur la vitrine',
  },
  auto_confirm: {
    label: 'Confirmer automatiquement les réservations',
  },
  email: {
    label: 'E-mail pour les réservations entrantes',
    add: 'Ajouter un e-mail',
    placeholder: "Saisir l'e-mail",
    required: 'Ajoutez au moins une adresse e-mail pour recevoir les nouvelles réservations.',
    invalid: 'Saisissez une adresse e-mail valide.',
  },
  has_whatsapp_phone_number: {
    label: 'Envoyer les notifications via WhatsApp',
  },
  whatsapp_phone_number: {
    label: 'Numéro WhatsApp',
    add: 'Ajouter un numéro de téléphone',
  },
  party_size: {
    label: 'Taille de groupe autorisée par réservation',
    min_label: 'Min',
    max_label: 'Max',
    to: 'à',
    guests: 'convives',
    helper:
      "Taille minimale et maximale d'une réservation. Un client ne peut réserver que pour un nombre de personnes compris dans cette plage.",
    warning:
      "Google n'accepte que les réservations pour 2 à 16 convives. Les réservations hors de cette plage fonctionneront sur votre vitrine, mais n'apparaîtront pas sur Google.",
    warning_min: 'Google recommande un minimum de 2 convives pour les réservations.',
    warning_max: 'Google recommande un maximum de 16 convives pour les réservations.',
    min_note: 'Google ne proposera pas de réservations pour les groupes de moins de {{count}} personnes.',
  },
  time_slot: {
    label: 'Intervalle de réservation',
    helper: 'Les clients peuvent réserver par tranches de ce nombre de minutes.',
    extra: 'ex. {{example}}',
  },
  reservation_gap: {
    label: 'Délai limite avant fermeture',
    helper: "Dernière heure à laquelle un client peut débuter une réservation, calculée depuis l'heure de fermeture.",
    helper_link: 'Voir vos horaires de réservation',
    extra: 'ex. fermeture à 22 h, délai {{example}} min → dernier créneau disponible à {{example}}',
  },
  reservation_notice_period: {
    label: 'Préavis minimum',
    helper: "Délai minimum avant l'heure d'arrivée pour qu'un client puisse réserver.",
    extra: 'ex. réserver avant {{example}} pour une arrivée à 18 h',
  },
  opening_times: {
    label: "Horaires d'ouverture",
  },
  total_seats: {
    label: 'Capacité totale de convives',
    helper:
      'Nombre maximum de convives (et non de tables) pouvant être assis simultanément. Comptez les places individuelles — ex. 5 tables de 4 = 20.',
  },
  capacity_explainer: {
    title: 'Fonctionnement de la capacité',
    body: "Il s'agit du nombre de convives que vous pouvez accueillir simultanément. Chaque réservation occupe ses places pour sa durée, puis les libère pour les convives suivants. Le système réserve suffisamment de places pour tous, évitant tout surbooking.",
    body_example:
      "Exemple : avec 20 places, vous pouvez accepter une réservation de 12 convives à 19 h et une de 10 convives à 21 h, car les places du premier groupe se libèrent avant l'arrivée du suivant.",
  },
  note: {
    label: 'Remarque',
  },
  grace_period: {
    label: 'Période de grâce',
    helper: "Durée pendant laquelle une table est maintenue après l'heure de début de la réservation.",
    tooltip:
      "Délai supplémentaire ajouté après la durée d'une réservation avant que la table soit proposée à nouveau (ex. pour la nettoyer et la remettre en place).",
    extra: "ex. maintenu jusqu'à {{example}} pour une réservation à 18 h",
    placeholder: 'Saisir la période de grâce',
  },
  information: {
    rules: {
      label: 'Votre table sera réservée pendant :',
      add: 'Ajouter',
    },
  },
  reservation_duration: {
    label: 'Durée de réservation',
    helper: 'Durée pendant laquelle chaque table est occupée par réservation.',
    tooltip:
      'Durée pendant laquelle une table est réservée pour chaque client. Utilisée pour calculer quand la table se libère pour le convive suivant.',
    extra: 'ex. 18 h – {{example}}',
    minutes: '{{ count }} minutes',
    hour_one: '{{ count }} heure',
    hour_other: '{{ count }} heures',
  },
  buttons: {
    save: 'Enregistrer',
    activate: 'Activer',
    deactivate: 'Désactiver',
  },
  success_messages: {
    updated: 'Mise à jour réussie',
    saving_successful:
      "Mise à jour réussie. Veuillez noter que Google peut mettre jusqu'à 24 heures à refléter les modifications.",
  },
  error_messages: {
    invalid_phone_number: 'Numéro de téléphone invalide',
    saving_unsuccessful: "Erreur lors de l'enregistrement des modifications. Veuillez réessayer.",
    enter_correct_email: 'Veuillez saisir une adresse e-mail valide.',
  },
};
